export class InvestigationSavedFilterEntity {
  public id!: string;
  public name!: string;
  public description!: string | null;
  public filter!: string;
  public isSystem!: boolean;
  public isActive!: boolean;
  public displayOrder!: number;
  public count!: number;
}
